export default __webpack_public_path__ + "static/media/Plastic-Bags.88a43ada.jpg";